import React from 'react'

export default function ImageSlide({ src, alt, isActive, onError }) {
  return (
    <div
      className={`media-slide image-slide ${isActive ? 'active' : ''}`}
      data-testid="image-slide">
      <img
        src={src}
        alt={alt || 'Screensaver content'}
        onError={onError}
        style={{
          width: '100%',
          height: '100vh',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </div>
  )
}
